import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { User, UserAdmin } from '../../../api/interface';
import type { StoreState } from '../../../data/store';
import { actions as usersSliceActions } from '../../../data/users/logic';
import type { UserForm } from './NewUserModal';

export interface UsersHookState {
  users: User[];
  usersAdmin?: UserAdmin[];
  actions: StoreState['users']['actions'];
}

interface UsersHookHandler {
  fetchUsers(): void;
  fetchUsersAdmin(): void;
  createUser(user: UserForm): void;
  deleteUsers(emails: string[]): void;
  resendSignInEmail(email: string): void;
}

const useUsersHook = (): [UsersHookState, UsersHookHandler] => {
  const dispatch = useDispatch();
  const {
    users = [],
    usersAdmin = [],
    actions,
  } = useSelector((s: StoreState) => s['users']);

  const handler = React.useMemo(
    () => ({
      fetchUsers: () => {
        dispatch(usersSliceActions.users());
      },
      fetchUsersAdmin: () => {
        dispatch(usersSliceActions.usersAdmin());
      },
      createUser: (user: UserForm) => {
        dispatch(usersSliceActions.createUser(user));
      },
      deleteUsers: (emails: string[]) => {
        dispatch(usersSliceActions.deleteUsers(emails));
      },
      resendSignInEmail: (email: string) => {
        dispatch(usersSliceActions.resendSignInEmail(email));
      },
    }),
    []
  );

  return [{ users, usersAdmin, actions }, handler];
};

export default useUsersHook;
